import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'feron_cookie_consent';

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY); // 'accepted' | 'rejected' | null
  } catch {
    return null;
  }
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      /* storage unavailable — stay hidden */
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 z-[70] w-[calc(100%-2rem)] max-w-md animate-[slideUp_0.4s_ease-out]"
      style={{ animationName: 'cookieSlideUp' }}
    >
      <style>{`@keyframes cookieSlideUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div className="relative rounded-2xl bg-black text-white shadow-2xl ring-1 ring-white/10 p-5 pr-9">
        <button
          onClick={() => decide('rejected')}
          aria-label="Dismiss cookie banner"
          data-testid="cookie-dismiss-btn"
          className="absolute top-3 right-3 text-white/50 hover:text-white transition-colors"
        >
          <X size={18} />
        </button>
        <div className="flex items-start gap-3">
          <div className="mt-0.5 h-9 w-9 shrink-0 rounded-full bg-[#22c55e] text-black flex items-center justify-center">
            <Cookie size={18} />
          </div>
          <div className="space-y-2">
            <p className="text-sm leading-relaxed text-white/85">
              We use cookies to keep your cart, remember your region and improve your experience.
              You can accept all cookies or continue with only the essentials.{' '}
              <Link
                to="/privacy-policy"
                className="underline text-[#22c55e] hover:text-[#4ade80]"
                data-testid="cookie-policy-link"
              >
                Learn more
              </Link>
            </p>
            <div className="flex flex-wrap gap-2 pt-1">
              <button
                onClick={() => decide('accepted')}
                data-testid="cookie-accept-btn"
                className="rounded-full bg-[#22c55e] hover:bg-[#1ea34d] text-black text-sm font-semibold px-5 py-2 transition-colors"
              >
                Accept all
              </button>
              <button
                onClick={() => decide('rejected')}
                data-testid="cookie-reject-btn"
                className="rounded-full border border-white/25 hover:border-white/50 text-white text-sm font-semibold px-5 py-2 transition-colors"
              >
                Essentials only
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
